import { Routes, Route } from "react-router-dom";

import { InterviewBookingPage } from "@/client_app/components/InterviewBookingPage";
import { InterviewSettingUpPage } from "@/client_app/components/InterviewSettingUpPage";
import { NotFound } from "@/client_app/components/NotFound";
import { useHighlights } from "@/client_app/context/HighlightContext";
import {
  monashTimesheetApprovalRoutes,
  timesheetApprovalRoutes,
} from "@/client_app/features/timesheetApproval/routes";
import {
  studentsRoutes,
  weployeesRoutes,
} from "@/client_app/features/weployees/routes";
import { useApplyHighlights } from "@/client_app/hooks/useApplyHighlights";

export const AppRoutes = (): JSX.Element => {
  const highlights = useHighlights();
  useApplyHighlights(highlights);
  return (
    <Routes>
      {timesheetApprovalRoutes}
      {monashTimesheetApprovalRoutes}
      {weployeesRoutes}
      {studentsRoutes}
      <Route path='/weployer/timesheets/*' element={<NotFound />} />
      <Route
        path='/weployer/interview/booking/:id'
        element={<InterviewBookingPage />}
      />
      <Route
        path='/weployer/interview/setting-up/:id'
        element={<InterviewSettingUpPage />}
      />
      <Route path='/weployer/weployees/*' element={<NotFound />} />
    </Routes>
  );
};
